export enum AppModeEnum {
  Default = 'default',
  MatchPreview = 'match_preview',
  GoogleEmailOauth = 'google_email_oauth',
  MicrosoftEmailOauth = 'microsoft_email_oauth',
}
